import { MatTableDataSource } from '@angular/material/table';
import { MatMultiSortDirective } from '@dice/app/components/organisms/mat-multi-sort/mat-multi-sort.directive';

export class MatMultiSortTableDataSource<T> extends MatTableDataSource<T> {
  _multiSort: MatMultiSortDirective;

  constructor(sort: MatMultiSortDirective) {
    super();
    this._multiSort = sort;
  }

  orderData(): void {
    if (!this._multiSort) {
      return;
    }
    this.data = this._sortData(this.data, this._multiSort.actives, this._multiSort.directions);
  }

  private _sortData(data: T[], actives: string[], directions: string[]): T[] {
    return data.sort((i1, i2) => {
      return this.__sortData(i1, i2, actives, directions);
    });
  }

  private __sortData(d1: any, d2: any, params: string[] | any[], dirs: string[]): number {
    let v1 = d1[params[0]];
    let v2 = d2[params[0]];

    // the backend is sending all values as strings. e.g. for a time value will be sent "650" (seconds) which will be formatted to "00:10:30", or "00:10:30" directly
    // in order to be able to compare and sort these values, we parse them to integers
    // e.g. "650" (string) will be converted to 650 (number) and "00:10:30" (string) will be converted to 630 (number)
    // the "null check" is required, because sometimes the backend is sending "undefined" values
    // so if a value is "undefined", we will just convert it to an empty string, in order to make the sorting work
    if (this.isTimestamp(v1)) {
      v1 = this.convertTimestampToNumber(v1.toString());
    } else if (this.isPositiveInteger(v1)) {
      v1 = Number(v1);
    } else if (!v1) {
      v1 = '';
    }

    if (this.isTimestamp(v2)) {
      v2 = this.convertTimestampToNumber(v2.toString());
    } else if (this.isPositiveInteger(v2)) {
      v2 = Number(v2);
    } else if (!v2) {
      v2 = '';
    }

    if (v1 > v2) {
      return dirs[0] === 'asc' ? 1 : -1;
    }
    if (v1 < v2) {
      return dirs[0] === 'asc' ? -1 : 1;
    }
    if (params.length > 1) {
      params = params.slice(1, params.length);
      dirs = dirs.slice(1, dirs.length);
      return this.__sortData(d1, d2, params, dirs);
    }
    return 0;
  }

  private isPositiveInteger(n): boolean {
    return n >>> 0 === parseFloat(n);
  }

  private isTimestamp(s): boolean {
    const hhmmssRegex: RegExp = new RegExp(/^(\d+):([0-5]?\d):([0-5]?\d)$/);
    const mmssRegex: RegExp = new RegExp(/^(\d]+):([0-5]?\d)$/);

    return hhmmssRegex.test(s) || mmssRegex.test(s);
  }

  private convertTimestampToNumber(s: string): number {
    const timestampSeparator: string = ':';
    const isHHmmss: boolean = (s.match(new RegExp(timestampSeparator, 'g')) || []).length === 2;
    const splitTimestamp: string[] = s.split(timestampSeparator);

    if (isHHmmss) {
      return Number(splitTimestamp[0]) * 3600 + Number(splitTimestamp[1]) * 60 + Number(splitTimestamp[2]);
    }

    return Number(splitTimestamp[0]) * 60 + Number(splitTimestamp[1]);
  }
}
